import { useEffect, useState } from 'react';

// ponytail: per-user, per-browser "viewed" marker in localStorage (SAA-155, Confluence AC 7.2).
// Keyed on the watchlist id — a regeneration is a new row (D3), so the badge reappears on its own.
// Move server-side (a `Watchlist.viewedAt` column) if it must survive a cleared browser or follow
// the user across devices.
const storageKey = (userId: number, watchlistId: number) => `watchlist-viewed:${userId}:${watchlistId}`;

const safeRead = (key: string) => {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

const safeWrite = (key: string) => {
  try {
    localStorage.setItem(key, '1');
  } catch {
    // storage unavailable (private mode / quota) — the badge simply stays until the next visit
  }
};

export const useWatchlistViewed = (userId?: number, watchlistId?: number, viewing = false) => {
  const key = userId && watchlistId ? storageKey(userId, watchlistId) : undefined;
  const [justViewedKey, setJustViewedKey] = useState<string>();

  // Syncing an external store is a legitimate effect; the state only forces the re-render the
  // write itself cannot.
  useEffect(() => {
    if (viewing && key) {
      safeWrite(key);
      setJustViewedKey(key);
    }
  }, [viewing, key]);

  return !!key && (justViewedKey === key || safeRead(key));
};
